import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const PATH_LABELS: Record<string, string> = {
  'features': '機能',
  'ai-task-breakdown': 'AIタスク分解',
  'ai-gantt': 'AIガントチャート',
  'ai-daily-report': 'AI日報',
  'ai-file-management': 'AIファイル管理',
  'team-collaboration': 'チーム機能',
  'multilingual': '多言語対応',
  'pricing': '料金',
  'security': 'セキュリティ',
  'free-trial': '無料トライアル',
  'contact': 'お問い合わせ',
  'compare': '比較',
  'project-management-tools': 'プロジェクト管理ツール比較',
  'excel-vs-project-management-tool': 'Excelと専用ツールの比較',
  'spreadsheet-vs-project-management-tool': 'スプレッドシートと専用ツールの比較',
  'ai-project-management-tools': 'AIプロジェクト管理ツール比較',
  'gantt-chart-tools': 'ガントチャートツール比較',
  'templates': 'テンプレート',
  'project-management-excel': 'プロジェクト管理Excelテンプレート',
  'gantt-chart-excel': 'ガントチャートExcelテンプレート',
  'wbs': 'WBSテンプレート',
  'project-status-report': 'プロジェクト状況報告書テンプレート',
  'guides': 'ガイド',
  'project-management': 'プロジェクト管理入門',
  'project-management-tool': 'プロジェクト管理ツールとは',
  'project-management-ai': 'プロジェクト管理×AI活用',
  'wbs-and-gantt-chart': 'WBSとガントチャートの違い',
  'gantt-chart': 'ガントチャートとは',
  'project-progress-management': 'プロジェクト進捗管理',
  'project-visualization': 'プロジェクトの見える化',
  'project-daily-report': 'プロジェクト日報',
  'project-schedule-management': 'プロジェクトスケジュール管理',
  'project-task-management': 'プロジェクトタスク管理',
  'project-information-sharing': 'プロジェクト情報共有',
  'project-document-management': 'プロジェクト文書管理',
  'project-milestone': 'プロジェクトマイルストーン',
  'project-dependency': 'プロジェクト依存関係',
  'critical-path': 'クリティカルパス',
  'project-management-failure': 'プロジェクト管理の失敗',
  'global-project-management': 'グローバルプロジェクト管理',
  'terms': '利用規約',
  'privacy': 'プライバシーポリシー',
  'commercial-law': '特定商取引法に基づく表記',
};

export default function Breadcrumb() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  if (segments.length === 0) return null;

  const items: BreadcrumbItem[] = [{ label: 'ホーム', path: '/' }];

  let currentPath = '';
  for (const seg of segments) {
    currentPath += `/${seg}`;
    items.push({
      label: PATH_LABELS[seg] || seg,
      path: currentPath,
    });
  }

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    'itemListElement': items.map((item, idx) => ({
      '@type': 'ListItem',
      'position': idx + 1,
      'name': item.label,
      'item': `https://omoimusubi.asia${item.path}`,
    })),
  };

  return (
    <>
      <nav aria-label="パンくずリスト" className="max-w-[1280px] mx-auto px-4 md:px-6 py-3">
        <ol className="flex items-center flex-wrap gap-1 text-xs text-foreground-500">
          {items.map((item, idx) => (
            <li key={item.path} className="flex items-center gap-1">
              {idx > 0 && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
              {idx === items.length - 1 ? (
                <span className="text-foreground-700 font-medium">{item.label}</span>
              ) : (
                <Link to={item.path!} className="hover:text-primary-600 transition-colors">
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
    </>
  );
}